import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getThemeClassNames } from 'themes';

import { MirrorService } from 'services/MirrorService';
import { AppDomain } from 'types/enums/AppDomain';

import { useHeaderMenuAnalytics } from 'hooks/analytics/useHeaderMenuAnalytics';
import {
  getHasNotifications,
  getNewDialogsCount,
} from 'store/common/selectors';

import { ReactComponent as DialogsIcon } from 'assets/icons/dialogs.svg';
import { ReactComponent as FinderIcon } from 'assets/icons/finder.svg';
import { ReactComponent as MyProfileIcon } from 'assets/icons/myprofile.svg';
import { ReactComponent as NotificationsIcon } from 'assets/icons/notifications.svg';

import { BaseButton, ButtonTypes } from 'components/base/BaseButton';
import { Logo } from 'components/shared/Logo';

import css from './mainPageMobileHeaderTypeHookupers.module.sass';

export const MainPageMobileHeaderTypeHookupers = () => {
  const { t } = useTranslation(['app', 'common']);

  const newDialogsCount = useSelector(getNewDialogsCount);
  const hasNotifications = useSelector(getHasNotifications);

  const {
    trackClickOnActivity,
    trackClickOnFinder,
    trackClickOnMyProfile,
    trackClickOnThreads,
  } = useHeaderMenuAnalytics();

  const iconClassName = getThemeClassNames(css.icon, {
    [AppDomain.Meamo]: css.iconThemeBlack,
    [AppDomain.Uniteus]: css.iconThemeBlack,
    [AppDomain.FlirtGuru]: css.iconThemeBlack,
    [AppDomain.DateaSoul]: css.iconThemeBlack,
    [AppDomain.SweatHeartSoul]: css.iconThemeBlack,
    [AppDomain.AdventuroUsDate]: css.iconThemeBlack,
    [AppDomain.SupremeDate]: css.iconThemeBlack,
    [AppDomain.TheCupies]: css.iconThemeBlack,
    [AppDomain.PerfectDatings]: css.iconThemeBlack,
    [AppDomain.DatingForLife]: css.iconThemeBlack,
    [AppDomain.ForeverLover]: css.iconThemeBlack,
    [AppDomain.FlirtingLover]: css.iconThemeBlack,
    [AppDomain.DatingsLover]: css.iconThemeBlack,
    [AppDomain.BeValentine]: css.iconThemeBlack,
    [AppDomain.OnesValentine]: css.iconThemeBlack,
    [AppDomain.DayDreamme]: css.iconThemeBlack,
    [AppDomain.DayDreamsDate]: css.iconThemeBlack,
    [AppDomain.LookLie]: css.iconThemeBlack,
    [AppDomain.Delightedus]: css.iconThemeBlack,
    [AppDomain.BestForFlirt]: css.iconThemeBlack,
    [AppDomain.PerfectFlirt]: css.iconThemeBlack,
    [AppDomain.MeetLie]: css.iconThemeBlack,
    [AppDomain.KlubMe]: css.iconThemeBlack,
    [AppDomain.Ppls]: css.iconThemeBlack,
    [AppDomain.Hitchii]: css.iconThemeBlack,
    [AppDomain.GotLinkedNow]: css.iconThemeBlack,
    [AppDomain.MeetHarbor]: css.iconThemeBlack,
    [AppDomain.TheLinkupers]: css.iconThemeBlack,
    [AppDomain.SoulMatesLab]: css.iconThemeBlack,
    [AppDomain.FairyDates]: css.iconThemeBlack,
    [AppDomain.WaitForMe]: css.iconThemeBlack,
    [AppDomain.LookFor4you]: css.iconThemeBlack,
    [AppDomain.TheManWoman]: css.iconThemeBlack,
    [AppDomain.UsTogether]: css.iconThemeBlack,
    [AppDomain.AmorPassion]: css.iconThemeBlack,
    [AppDomain.AmorFlames]: css.iconThemeBlack,
    [AppDomain.AmoreDesire]: css.iconThemeBlack,
    [AppDomain.JustLovebirds]: css.iconThemeBlack,
    [AppDomain.AdventureDate]: css.iconThemeBlack,
  });

  return (
    <>
      <header className={css.root}>
        <BaseButton
          type={ButtonTypes.Transparent}
          ariaLabel="home"
          to="/finder"
          className={css.logo}
        >
          <Logo
            dark={
              MirrorService.isUniteus ||
              MirrorService.isFlirtGuru ||
              MirrorService.isDateaSoul ||
              MirrorService.isDateaSoulmate ||
              MirrorService.isYourLove4Life ||
              MirrorService.isRelationshipNest ||
              MirrorService.isCupidKeys ||
              MirrorService.isAmourPulse ||
              MirrorService.isMyConnectly ||
              MirrorService.isTenderTalkers ||
              MirrorService.isSweatHeartSoul ||
              MirrorService.isRomanticWay ||
              MirrorService.isLovePath ||
              MirrorService.isGetParamour ||
              MirrorService.isTripToLove ||
              MirrorService.isSupremeDate ||
              MirrorService.isTheCupies ||
              MirrorService.isLookLie ||
              MirrorService.isPerfectDatings ||
              MirrorService.isDatingForLife ||
              MirrorService.isForeverLover ||
              MirrorService.isFlirtingLover ||
              MirrorService.isDatingsLover ||
              MirrorService.isBeValentine ||
              MirrorService.isOnesValentine ||
              MirrorService.isDayDreamme ||
              MirrorService.isDayDreamsDate ||
              MirrorService.isLookLie ||
              MirrorService.isDelightedus ||
              MirrorService.isBestForFlirt ||
              MirrorService.isPerfectFlirt ||
              MirrorService.isMeetLie ||
              MirrorService.isKlubMe ||
              MirrorService.isPpls ||
              MirrorService.isHitchii ||
              MirrorService.isSociableSpots ||
              MirrorService.isMeetNests ||
              MirrorService.isPeopleMeetClub ||
              MirrorService.isMeetHarbor ||
              MirrorService.isSoulMatesLab ||
              MirrorService.isTheLinkupers ||
              MirrorService.isFairyDates ||
              MirrorService.isWaitForMe ||
              MirrorService.isLookFor4you ||
              MirrorService.isTheManWoman ||
              MirrorService.isUsTogether ||
              MirrorService.isAmorPassion ||
              MirrorService.isAmorFlames ||
              MirrorService.isAmoreDesire ||
              MirrorService.isJustLovebirds ||
              MirrorService.isAdventureDate
            }
            hideBottomLine
            small
          />
        </BaseButton>

        <nav>
          <ul className={css.navList}>
            <li className={css.finderIcon}>
              <BaseButton
                type={ButtonTypes.Transparent}
                ariaLabel="finder"
                to="/finder"
                className={css.navBtn}
                onClick={trackClickOnFinder}
              >
                <FinderIcon className={iconClassName} />
              </BaseButton>
            </li>
            <li>
              <BaseButton
                type={ButtonTypes.Transparent}
                ariaLabel="messages"
                to="/threads"
                className={css.navBtn}
                onClick={trackClickOnThreads}
              >
                <>
                  <DialogsIcon
                    className={iconClassName}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                  />

                  {newDialogsCount > 0 && <div className={css.dot} />}
                </>
              </BaseButton>
            </li>
            <li>
              <BaseButton
                type={ButtonTypes.Transparent}
                ariaLabel="notifications"
                to="/notifications"
                className={css.navBtn}
                onClick={trackClickOnActivity}
              >
                <>
                  <NotificationsIcon className={iconClassName} />

                  {hasNotifications && <div className={css.dot} />}
                </>
              </BaseButton>
            </li>
            <li>
              <BaseButton
                type={ButtonTypes.Transparent}
                ariaLabel="profile"
                to="/myprofile"
                className={css.navBtn}
                onClick={trackClickOnMyProfile}
              >
                <>
                  <MyProfileIcon className={iconClassName} />
                </>
              </BaseButton>
            </li>
          </ul>
        </nav>
      </header>

      {MirrorService.isSweatHeartSoul && (
        <div className={css.terms}>
          <Link to="/terms" className={css.policyLink}>
            {t('app:termsOfUse')}
          </Link>
          <Link to="/refund-policy" className={css.policyLink}>
            {t('common:refundPolicy')}
          </Link>
          <Link to="/privacy-policy" className={css.policyLink}>
            {t('common:privacyPolicy')}
          </Link>
          <Link to="/tracking-policy" className={css.policyLink}>
            {t('common:trackingpolicy')}
          </Link>
        </div>
      )}
    </>
  );
};
